import { createSelector } from 'reselect';

import constants from './constants';

const selectWindshieldRepairabilityProfilesState = (state) => state[constants.NAME];

const selectWindshieldRepairabilityProfiles = createSelector(
  selectWindshieldRepairabilityProfilesState,
  ({ windshieldRepairabilityProfilesPagedResults }) => windshieldRepairabilityProfilesPagedResults
);

const getWindshieldRepairabilityProfileIdParam = (_, id) => id;

const selectWindshieldRepairabilityProfileById = createSelector(
  selectWindshieldRepairabilityProfiles,
  getWindshieldRepairabilityProfileIdParam,
  (pagedResults, id) => pagedResults?.results?.find((profile) => profile.id === id)
);

export default {
  selectWindshieldRepairabilityProfiles,
  selectWindshieldRepairabilityProfileById
};
